import React, { ReactNode } from "react";

// Interface pour les options
interface OptionType {
  id: string;
  label: string;
  value: string;
}

// Interface pour les props du SelectorMenu
interface SelectorMenuProps {
  options: OptionType[];
  value: string;
  onChange: (value: string) => void;
  label?: string | ReactNode;
  className?: string;
}

// Composant SelectorMenu avec typage et label inline
const SelectorMenu: React.FC<SelectorMenuProps> = ({
  options,
  value,
  onChange,
  label,
  className = "",
}) => {
  return (
    <div className={`${className}`}>
      <div className="flex items-center mb-2">
        {label && (
          <label className="text-sm font-medium text-gray-700 mr-3 whitespace-nowrap">
            {label}
          </label>
        )}
        <select
          className="w-full p-2 border rounded-lg bg-white shadow-sm"
          value={value}
          onChange={(e) => onChange(e.target.value)}
        >
          {options.map((option) => (
            <option key={option.id} value={option.value}>
              {option.label}
            </option>
          ))}
        </select>
      </div>
    </div>
  );
};

export default SelectorMenu;
